// Human copy for API error codes (the web's describeError, shared with the app).
import { RequestError } from "../client.js";
export const errorCopy = {
    unauthorized: "You need to sign in.",
    create_key_taken: "Something went wrong starting the club. Go back to your clubs and try again.",
    club_not_open: "This club asks people to request to join.",
    club_is_open: "This club is open: you can join straight away.",
    request_too_soon: "You can ask again 30 days after your last request.",
    too_many_requests: "You're waiting on 10 clubs already. Cancel one to ask another.",
    description_required: "Add a one-line description first: it's what people see when they find the club.",
    already_member: "You're already a member.",
    request_not_found: "That request has already been answered.",
    user_blocked: "This person can't join this club.",
    club_limit_reached: "You already own five clubs. Hand one off or delete one first.",
    invalid_slug: "Links use 3 to 40 lowercase letters, digits and hyphens.",
    slug_taken: "Another club already has that link.",
    host_not_a_member: "The host has to be a member of the club.",
    no_meeting: "There's no meeting on the calendar yet.",
    notes_closed: "Notes close a week after the meeting.",
    empty_question: "Write the question first.",
    question_too_long: "Keep questions under 500 characters.",
    question_already_discussed: "That one was already discussed at the meeting.",
    club_not_found: "That club doesn't exist, or you're not a member.",
    invite_not_found: "That invite link isn't valid.",
    invite_invalid: "This invite is no longer valid. Ask whoever sent it for a new one.",
    invite_expired: "That invite has expired. Ask for a new one.",
    invite_revoked: "That invite was revoked. Ask for a new one.",
    invite_used: "That invite was already used. Ask for a new one.",
    owner_must_transfer_first: "Transfer ownership to someone else before leaving.",
    cannot_remove_owner: "The owner can't be removed.",
    cannot_change_owner: "The owner's role can't be changed here. Use transfer ownership.",
    owner_required: "Only the owner can do that.",
    admin_required: "Only admins can do that.",
    already_owner: "They already own this club.",
    catalog_unavailable: "Book search isn't set up yet.",
    catalog_rate_limited: "Hardcover is rate-limiting us. Try again in a minute.",
    catalog_error: "Hardcover didn't answer. Try again.",
    query_too_short: "Type at least two letters.",
    book_not_found: "Hardcover doesn't know that book.",
    book_already_on_shelf: "The club is reading that one right now.",
    suggestion_cap: "You have as many suggestions going as this club allows. Move one of yours to Past to make room.",
    suggestion_note_too_long: "Keep it to 140 characters.",
    not_your_suggestion: "Only whoever suggested it can write its note.",
    no_bump_left: "You've already brought this one back once. Someone else wanting it will bring it back.",
    on_deck_in_vote: "It's on the ballot right now. Wait for the vote to close.",
    need_two_books: "A vote needs at least two books on deck.",
    club_already_has_current_book: "Finish or shelve the current book first.",
    only_on_deck_books_can_be_removed: "Only books on deck can be removed.",
    book_not_started: "The club hasn't started this book yet.",
    book_not_on_deck: "That only works while the book is on deck.",
    book_not_current: "The club isn't reading this one right now.",
    not_sitting_out: "You're already reading it.",
    already_done: "You've already finished with this one.",
    book_not_finished: "That's for books the club has finished.",
    invalid_stars: "Pick between half a star and five, in halves.",
    invalid_meeting_time: "That date and time didn't parse.",
    invalid_started_at: "That start date didn't parse.",
    invalid_finished_at: "That finish date didn't parse.",
    started_at_in_future: "The start date can't be in the future.",
    finished_at_in_future: "The finish date can't be in the future.",
    started_after_finished: "The start date has to be before the finish date.",
    hardcover_unavailable: "Hardcover linking isn't set up on this server.",
    comment_locked: "That comment is ahead of where you are. Read on to reply.",
    comment_not_found: "That comment is gone.",
    not_your_comment: "You can only edit your own comments.",
    not_your_question: "Only whoever asked can do that.",
    unknown_genre: "That genre isn't on the list.",
    early_reveal_off: "This club keeps spoiler answers sealed until you get there.",
    empty_comment: "Write something first.",
    comment_too_long: "That's over 4,000 characters. Split it up.",
    quote_too_long: "A quote can be up to 1,000 characters.",
    empty_note: "Write something first.",
    note_too_long: "That's over 4,000 characters.",
    note_not_found: "That note is gone.",
    already_shared: "You already shared that one.",
    not_finished: "You haven't reached the end yet.",
    gave_up: "You marked this one as done with.",
    already_finished: "You finished this one.",
    cannot_delete_finish_line: "The finish line stays.",
    cannot_edit_finish_line: "The finish line stays as it is.",
    empty_post: "Write something first.",
    post_too_long: "A post can be up to 1,000 characters.",
    post_not_found: "That post is gone, or it moved to Talk.",
    not_your_post: "You can only edit your own posts.",
    cannot_pin_reply: "Only posts can be pinned, not replies.",
    cannot_move_reply: "Only posts can move, not replies. Their replies go with them.",
    pin_until_past: "Pick a date that's still ahead.",
    no_current_book: "The club isn't reading anything right now.",
    position_below_author: "It can't land before where its author was when they posted.",
    invalid_time_zone: "That time zone isn't one we know.",
    quiet_hours_need_both: "Quiet hours need a start and an end.",
    notification_type_critical: "That one can't be turned off.",
    invalid_email: "That doesn't look like an email address.",
    email_unavailable: "This server doesn't send email.",
    email_unavailable_today: "We can't send email right now. Try again tomorrow, or use another way to sign in.",
    too_many_codes: "That's a lot of codes. Wait a while, then ask again.",
    code_wrong: "That code doesn't match. Check the newest email.",
    code_cancelled: "Too many wrong tries, so that code stopped working. Ask for a new one.",
    code_expired: "That code has run out. Ask for a new one.",
    code_invalid: "That code has been used or has run out. Ask for a new one.",
    address_in_use: "Another account already uses that address.",
    email_not_confirmed: "Confirm that address first.",
    last_sign_in: "This is your only way to sign in. Add another first.",
    device_not_found: "That device is already gone.",
    position_past_you: "A note can only wait at a page you've reached.",
    too_many_notes: "You have 10 notes waiting in this book. One has to arrive or be deleted first.",
    recipient_not_behind: "They're already past that page.",
    forward_note_too_long: "That's longer than 500 characters.",
    prediction_locked: "Your prediction is sealed now.",
    prediction_closed: "Predictions close at 15% of the book.",
    prediction_too_long: "That's longer than 280 characters.",
};
export const somethingWentWrong = "Something went wrong. Try again.";
/** Human copy for an API error. Unknown codes fall back to the server's message, then the code itself. */
export function describeError(e) {
    if (!(e instanceof RequestError))
        return somethingWentWrong;
    return errorCopy[e.code] ?? e.message ?? e.code;
}
//# sourceMappingURL=errors.js.map